import PropTypes from 'prop-types';
import React from 'react';

import { o2oPermissions } from '../../utils/tab-permissions';
import { PageTemplate } from '../reusable';

import BulkUpdate from './BulkUpdate';

const O2OBulkUpdate = (props) => (
  <PageTemplate
    auth={o2oPermissions}
    description="Apply BOPIS or Ship From Store configuration to many stores at once."
    help={(
      <a
        className="ncss-cta-primary-dark underline text-color-secondary"
        href="https://confluence.nike.com/display/RCFITC/RCF+KB+-+O2O+Capabilities+UI"
        rel="noopener noreferrer"
        target="_blank"
      >
        Click here to view the KB
      </a>
    )}
    page={<BulkUpdate />}
    path={props.location.pathname}
    title="O2O Bulk Update"
  />
);

O2OBulkUpdate.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string.isRequired }).isRequired,
};

export default O2OBulkUpdate;
